<template>
    <div class="auth-page">
        <div class="auth-card">
            <form @submit.prevent="login" autocomplete="off">
                <div class="auth-logo">
                    <img src="../assets/img/Dark.svg" alt="SuperQR" width="160" height="50">
                </div>
                <h5 class="auth-title">{{ $t('login.title') }}</h5>
                <div class="mb-3">
                    <label for="username" class="form-label">{{ $t('login.email') }}</label>
                    <input type="text" class="form-control" name="username" id="username" autocomplete="off" v-model="username" placeholder="you@company.com" required>
                    <span v-if="usernameError" class="field-error">{{ usernameError }}</span>
                </div>
                <div class="mb-4">
                    <label for="password" class="form-label">{{ $t('login.password') }}</label>
                    <input type="password" class="form-control" name="password" id="password" autocomplete="off" v-model="password" :placeholder="$t('login.passwordPlaceholder')" required>
                    <span v-if="passwordError" class="field-error">{{ passwordError }}</span>
                </div>
                <button type="submit" class="btn btn-primary w-100 btn-lg">{{ $t('login.submit') }}</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        username: '',
        password: '',
        usernameError: '',
        passwordError: ''
    }),
    mounted() {
        this.$emit('setPageTitle', '')
    },
    methods: {
        async login() {
            this.usernameError = ''
            this.passwordError = ''
            if(!this.username) { this.usernameError = this.$t('login.emailRequired'); return }
            if(!this.password) { this.passwordError = this.$t('login.passwordRequired'); return }

            let response = await this.$api.login(this.username, this.password)

            if(response.result === 'ERROR') {
                this.passwordError = response.msg
            } else if(response.result === 'SUCCESS') {
                this.$router.push('/plans')
            }
        }
    }
}
</script>

<style scoped>
.auth-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f5f3ff 0%, #fdf2f8 50%, #fff7ed 100%);
    padding: 2em;
}

.auth-card {
    background: var(--bg-card);
    border-radius: var(--border-radius-lg);
    box-shadow: var(--shadow-lg);
    padding: 2.5em;
    width: 100%;
    max-width: 400px;
}

.auth-logo {
    text-align: center;
    margin-bottom: 1.5em;
}

.auth-title {
    text-align: center;
    margin-bottom: 1.5em;
    font-size: 18px;
    color: var(--text-primary);
}

.btn-lg {
    padding: 0.7em 1.5em;
    font-size: 14px;
    border-radius: var(--border-radius-sm);
}

.field-error {
    display: block;
    font-size: 12px;
    color: #ef4444;
    margin-top: 0.35em;
}

.auth-footer {
    text-align: center;
    margin-top: 1.5em;
    font-size: 13px;
    color: var(--text-secondary);
}

.auth-footer a {
    margin-left: 0.35em;
    font-weight: 500;
}
</style>
